<template>
    <div class="v-flex">
        <c-import-quality-tag
            :count = "getCount(item, 3)"
            color  = "error"
        />
        <c-import-quality-tag
            :count = "getCount(item, 2)"
            color  = "warning"
        />
        <c-import-quality-tag
            :count = "getCount(item, 1)"
            color  = "success"
        />
    </div>
</template>

<script>

import CImportQualityTag from "@/modules/inb/components/controlls/CImportQualityTag";

export default {
    name: "CInboxQuality",

    components: {
        CImportQualityTag
    },

    props: {
        item: {},
        allMode: {
            type   : Boolean,
            default: false,
        },
    },

    data: () => ({
    }),

    computed: {
        customerCounts () {
            return this.$store.getters.customerQualityCounts;
        }
    },

    methods: {
        getCount (customer, qualityId) {
            if (!this.customerCounts) {
                return null;
            }

            if (this.allMode) {
                const total = this.customerCounts
                    .filter(c => c.qualityId === qualityId)
                    .reduce((sum, c) => sum + (c.count || 0), 0);
                return total || null;
            }

            const customerId = customer ? customer.id : 0;
            const value = this.customerCounts.find(c => c.customerId === customerId && c.qualityId === qualityId);
            return value ? value.count : null;
        },
    }
}
</script>

<style scoped>

</style>